import { render, staticRenderFns } from "./ReasonModal.vue?vue&type=template&id=5c3d415f&scoped=true"
import script from "./ReasonModal.vue?vue&type=script&lang=js"
export * from "./ReasonModal.vue?vue&type=script&lang=js"
import style0 from "./ReasonModal.vue?vue&type=style&index=0&id=5c3d415f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3d415f",
  null
  
)

export default component.exports